import { render, staticRenderFns } from "./VisualizacionSeguidoresPopularidadArtistas.vue?vue&type=template&id=e0dc97ce&scoped=true&"
import script from "./VisualizacionSeguidoresPopularidadArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionSeguidoresPopularidadArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionSeguidoresPopularidadArtistas.vue?vue&type=style&index=0&id=e0dc97ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dc97ce",
  null
  
)

export default component.exports